<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>

    <div id="map" class="mappa"></div>
    <div class="flottante">
      <div class="slds-grid">
        <div class="slds-col">
          <gnetOptions v-bind:options="optAnni" v-bind:values="anni" v-bind:label="'Selezionare le annate da visualizzare'" v-on:change="cambiaAnni($event)"></gnetOptions>
        </div>
        <div class="slds-col">
          <gnetOptions v-bind:options="optCampagne" v-bind:values="campagne" v-bind:label="'Selezionare le campagne'" v-on:change="cambiaCampagna($event)"></gnetOptions>
        </div>
      </div>
      <div id="calendar_basic"></div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetMixLib from '@/mixin.js'
import gnetOptions from '../components/options.vue'
import apiclient from '@/apiclient.js'
import moment from 'moment'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetOptions,
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    }
  },
  watch: {
    actualdealer: function() {
      this.getRecords();
    }
  },
  data: function() {
    return {
      records:[],
      map:{},
      showheader: true,
      anni: { 2022:false, 2023:false, 2024:false, 2025:true, 2026:true},
      campagne: { PW:true, SC:false, NA:false, RE: false, VF: false, MO: false },
      optAnni: [
        { label:'2023', id:'2023'},
        { label:'2024', id:'2024'},
        { label:'2025', id:'2025'},
        { label:'2026', id:'2026'},
      ],
      optCampagne: [
        { label:'VF', id:'VF'},
        { label:'PW', id:'PW'},
        { label:'SC', id:'SC'},
        { label:'NA', id:'NA'},
        { label:'RE', id:'RE'},
        { label:'MO', id:'MO'},
      ],
      chartoptions: {},
      markers:[],
      lines:[]
    };
  },
  created: function() {
  },
  mounted: function() {
    // eslint-disable-next-line no-undef
    google.charts.load("current", { packages: ["calendar"] });
    // eslint-disable-next-line no-undef
    google.charts.setOnLoadCallback(this.drawCal);
    this.initMap();
    this.getRecords();
  },
  methods: {
    updateMap:function() {
      this.getRecords();
    },
    clearMarker: function() {
      this.markers.forEach(function(m) {
        m.setMap(null);
      });
      this.markers=[];
      this.lines.forEach(function(m) {
        m.setMap(null);
      });
      this.lines=[];
    },
    selectData: function(d1) {
      var d2=moment(d1).format('YYYY-MM-DD');
      console.log(d2);
      this.clearMarker();

      // eslint-disable-next-line no-undef
      var bounds = new google.maps.LatLngBounds();


      this.records.forEach(function(d,i) {
        if (d.Data_Ordine__c==d2) {
          // eslint-disable-next-line no-undef
          var location = new google.maps.LatLng(d.Account__r.BillingLatitude, d.Account__r.BillingLongitude);
          this.addMarker(location, d.FCP_COPYCMSYEAR__c, (this.markers.length+1)+'');
          bounds.extend(location);
          this.map.fitBounds(bounds);
        }
      }, this)
      this.addDirection('2025');
    },
    updateCalendar: function() {
      var dateordini=new Map();
      this.records.forEach(function(d,i) {
        if (!dateordini.has(d.Data_Ordine__c)) dateordini.set(d.Data_Ordine__c, { nordini:0, ordini:[]});
        var o=dateordini.get(d.Data_Ordine__c);
        o.nordini++;
        o.ordini.push(d);
      }, this)
      // eslint-disable-next-line no-undef
      var dataTable = new google.visualization.DataTable();
      dataTable.addColumn({ type: 'date', id: 'Data' });
      dataTable.addColumn({ type: 'number', id: 'N.Ordini' });

      for (var o of dateordini) {
        // var x={ data: moment(o[0]).toDate(), ordini: o[1].nordini }
        dataTable.addRow( [ moment(o[0]).toDate(), o[1].nordini ] );
        // dataTable.addRow( [ x.data, x.ordini ] );
      }
      this.chart.draw(dataTable, this.chartoptions);

    },
    getRecords: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var soql="select FCP_COPYCMSYEAR__c, account__r.BillingLatitude, account__r.BillingLongitude, Data_Ordine__c, FCP_COPYCMSWEEK__c from ordine__c where id in (select ordine__c from riga_ordine__c where";
        var filter=[];
        if (self.anni['2020']) filter.push("'2020'");
        if (self.anni['2021']) filter.push("'2021'");
        if (self.anni['2022']) filter.push("'2022'");
        if (self.anni['2023']) filter.push("'2023'");
        if (self.anni['2024']) filter.push("'2024'");
        if (self.anni['2025']) filter.push("'2025'");
        if (self.anni['2026']) filter.push("'2026'");
        console.log(self.campagne);
        var filter2=[];
        if (self.campagne['PW']) filter2.push("'PW'");
        if (self.campagne['SC']) filter2.push("'SC'");
        if (self.campagne['NA']) filter2.push("'NA'");
        if (self.campagne['RE']) filter2.push("'RE'");
        if (self.campagne['VF']) filter2.push("'VF'");
        if (self.campagne['MO']) filter2.push("'MO'");
        if (filter.length>0) soql+=" FCP_COPYCMSYEAR__c in ("+filter.join(',')+") and ";
        if (filter2.length>0) soql+=" ID_Campagna__c in ("+filter2.join(',')+")  ";
        soql+=") and Tipo_Ordine__c!='Reso' and account__r.zona_1__c='"+self.$store.getters.zona+"'";
        soql+=" order by FCP_COPYCMSYEAR__c, Data_Ordine__c, name"

        console.log(soql);
        //this.busy=true;
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          self.busy=false;
          self.records=[];
          if (data.length>0) {
            self.records=data;
            self.updateCalendar();
          }
          resolve();
        }).catch(function(err){
          console.log(err);
          reject();
        })
      })
    },
    initMap: function() {
        const centromappa = { lat: 41.87194, lng: 12.56738 };
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(document.getElementById("map"), {
            zoom: 5,
            center: centromappa,
        });
    },
    drawCal:function() {
      // eslint-disable-next-line no-undef
      var dataTable = new google.visualization.DataTable();
      dataTable.addColumn({ type: 'date', id: 'Data' });
      dataTable.addColumn({ type: 'number', id: 'N.Ordini' });
      // eslint-disable-next-line no-undef
      this.chart = new google.visualization.Calendar(document.getElementById('calendar_basic'));

      this.chartoptions = {
          title: "Calendario Ordini",
          calendar: { cellSize: 10 },
          height: 250,
      };

      // eslint-disable-next-line no-undef
      // var formatDate = new google.visualization.DateFormat({ pattern: 'yyyy-MM-dd' });

      var self=this;
      // eslint-disable-next-line no-undef
      google.visualization.events.addListener(this.chart, 'select', function () {
        var d=self.chart.getSelection();
        console.log(d);
        if (d.length>0)
          self.selectData(d[0].date);
      });

      this.chart.draw(dataTable, this.chartoptions);

    },
    pinSymbol(color) {
        return {
            path: 'M 0,0 -1,-2 V -43 H 1 V -2 z M 1,-40 H 30 V -20 H 1 z',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 2,
            scale: 1,
            // eslint-disable-next-line no-undef
            labelOrigin: new google.maps.Point(15, -30)
        };
    },
    addDirection(year) {
      if (this.markers.length > 1) {
        console.log('adding')
        var color;
        if (year == 2020) color = "red"; else color = "blue";
        for (var i = 0; i < this.markers.length; i++) {
          if (i != this.markers.length - 1) {
            // eslint-disable-next-line no-undef
            var lineSymbol = { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW };
            // eslint-disable-next-line no-undef
            var line = new google.maps.Polyline({
              path: [ this.markers[i].position, this.markers[i + 1].position ],
              icons: [ { icon: lineSymbol, offset: "100%" } ],
              map: this.map,
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 1.5
            });
            this.lines.push(line);
          }
        }
      }
    },

    addMarker(location, year, number) {
        // eslint-disable-next-line no-undef
        var marker = new google.maps.Marker({
            position: location,
            map: this.map,
            label: {
                text: number,
                fontWeight: "bold",
                color: 'white',
                background: 'white'
            },
        });
        if (year == 2020) {
            marker.setIcon(this.pinSymbol("red"));
        }
        else {
            marker.setIcon(this.pinSymbol("blue"));
        }
        this.markers.push(marker);
    },
    cambiaAnni:function(e) {
      this.anni[e]=!this.anni[e];
      this.updateMap();
    },
    cambiaCampagna:function(e) {
      this.campagne[e]=!this.campagne[e];
      this.updateMap();
    }
  }
}
</script>
<style scoped>
  .mappa {
      width: 100%;
      height: 650px;
  }
  .flottante {
    z-index: 2;
    width: 600px;
    height: 275px;
    position: absolute;
    bottom: 10px;
    left: 10px;
    border: 1px solid #808080;
    background-color: #707070ad;
  }
</style>

